module.exports = __webpack_public_path__ + "static/img/pc_logo.cdcf15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/pc_logo.png
// module id = pV3S
// module chunks = 1 3